import { render, staticRenderFns } from "./PlmFileList.vue?vue&type=template&id=37f83cd7&scoped=true"
import script from "./PlmFileList.vue?vue&type=script&lang=js"
export * from "./PlmFileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f83cd7",
  null
  
)

export default component.exports